import { render } from "./FAQView.vue?vue&type=template&id=6b251d48&lang=pug"
const script = {}

import exportComponent from "C:\\Users\\User\\Desktop\\nxin_0501\\nxin_vue\\前台程式\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__